import { VENDOR_VALIDATION } from '../constants';

export const vendorValidationRules = {
  name: (value?: string) => {
    if (!value?.trim()) return 'Vendor name is required';
    if (value.length < VENDOR_VALIDATION.NAME_MIN_LENGTH) {
      return `Name must be at least ${VENDOR_VALIDATION.NAME_MIN_LENGTH} characters`;
    }
    return '';
  },
  
  contact_person: (value?: string) => {
    if (!value?.trim()) return 'Contact person is required';
    return '';
  },
  
  phone: (value?: string) => {
    if (!value) return '';
    if (!VENDOR_VALIDATION.PHONE_REGEX.test(value)) {
      return 'Invalid phone number format';
    }
    return '';
  },
  
  email: (value?: string) => {
    if (!value) return '';
    if (!VENDOR_VALIDATION.EMAIL_REGEX.test(value)) {
      return 'Invalid email format';
    }
    return '';
  },
  
  address: (value?: string) => {
    if (!value) return '';
    if (value.length < VENDOR_VALIDATION.ADDRESS_MIN_LENGTH) {
      return `Address must be at least ${VENDOR_VALIDATION.ADDRESS_MIN_LENGTH} characters`;
    }
    return '';
  }
} as const;